export default __webpack_public_path__ + "static/media/Teddybär.abd03046.webp";